import styled from 'styled-components';
import shadow from '~/assets/images/shop/shadow.png';

const StyledShadow = styled.div`
	position: absolute;
	width: 2000px;
	height: 2000px;
	background: url(${shadow}) no-repeat center;
`;

export { StyledShadow };
